import { createApi } from "@reduxjs/toolkit/query/react";
import { components } from "../../types/api";
import { baseQueryWithReauth } from "../../utils/baseQuery";

type DataModelResponse = components["schemas"]["DataModelResponse"];

export const dataModelApi = createApi({
  reducerPath: "dataModelApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getDataModelMappings: builder.query<DataModelResponse, void>({
      query: () => "/data-model",
    }),
  }),
});

export const { useGetDataModelMappingsQuery } = dataModelApi;
